<template>
  <div class="notification-filters">
    <!-- Filter Pills -->
    <div class="flex gap-2 overflow-x-auto px-4 py-3 scrollbar-hide">
      <button
        v-for="filter in filters"
        :key="filter.id"
        @click="selectFilter(filter.id)"
        :class="[
          'flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all',
          currentFilter === filter.id
            ? 'bg-primary text-white shadow-lg'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        ]"
      >
        <ImgComponent
          :src="filter.icon"
          fallback="/images/all/bell.svg"
          :alt="filter.label"
          class="w-4 h-4"
          v-if="filter.icon"
        />
        <span class="text-sm font-medium mr-4">{{ filter.label }}</span>
        <span
          v-if="filter.id !== 'all' && getUnreadCountForType(filter.id) > 0"
          :class="[
            'ml-1 px-2 py-0.5 rounded-full text-xs font-bold',
            currentFilter === filter.id
              ? 'bg-white text-primary'
              : 'bg-primary text-white'
          ]"
        >
          {{ getUnreadCountForType(filter.id) }}
        </span>
      </button>
    </div>

    <!-- Read Status Filter -->
    <div class="flex gap-2 px-4 py-2 border-t border-gray-200">
      <button
        @click="toggleReadStatus('all')"
        :class="[
          'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
          readStatusFilter === 'all'
            ? 'bg-primary text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        ]"
      >
        Toutes
      </button>
      <button
        @click="toggleReadStatus('unread')"
        :class="[
          'px-3 py-1.5 rounded-lg text-sm font-medium transition-all flex items-center gap-1',
          readStatusFilter === 'unread'
            ? 'bg-primary text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        ]"
      >
        Non lues
        <span
          v-if="unreadCount > 0"
          class="px-1.5 py-0.5 rounded-full text-xs font-bold"
          :class="
            readStatusFilter === 'unread'
              ? 'bg-white text-primary'
              : 'bg-primary text-white'
          "
        >
          {{ unreadCount }}
        </span>
      </button>
      <button
        @click="toggleReadStatus('read')"
        :class="[
          'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
          readStatusFilter === 'read'
            ? 'bg-primary text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        ]"
      >
        Lues
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import { NOTIFICATION_FILTERS } from '../constants';

const props = defineProps({
  unreadCount: {
    type: Number,
    default: 0
  },
  notifications: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['filter-change']);

const currentFilter = ref('all');
const readStatusFilter = ref('all');
const filters = NOTIFICATION_FILTERS;

const selectFilter = (filterId) => {
  currentFilter.value = filterId;
  emitFilterChange();
};

const toggleReadStatus = (status) => {
  readStatusFilter.value = status;
  emitFilterChange();
};

const emitFilterChange = () => {
  const filters = {
    type: currentFilter.value,
    readStatus: readStatusFilter.value
  };

  // Emit to parent
  emit('filter-change', filters);

  // Emit to bus for store to handle
  bus.emit(constants.EVENTS.INBOX.NOTIFICATION_FILTER_CHANGE, filters);
};

const getUnreadCountForType = (type) => {
  if (type === 'all') return props.unreadCount;

  return props.notifications.filter((n) => !n.read && n.type === type).length;
};

defineExpose({
  currentFilter,
  readStatusFilter,
  selectFilter,
  toggleReadStatus
});
</script>

<style scoped>
.notification-filters {
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 10;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
</style>
